module.exports = __webpack_public_path__ + "img/jt.d3484992.png";